import { SafePaddingContainer } from './SafePaddingContainer';
import { HeaderTitle } from './HeaderTitle';
import home from "@/assets/home.svg";
import settings from "@/assets/settings.svg";
import wallet from "@/assets/wallet.svg";
import winning from "@/assets/winning.svg";
import heart from "@/assets/support2.svg";
import tutorial from "@/assets/tutorial.svg";
import responsible from "@/assets/responsible.svg";
import chat from "@/assets/chat.svg";
import { Profile } from './Profile';
import { useModal } from '@/hooks/useModal';
import { TutorialModal } from './Modals/TutorialModal';
import {
    show as showIntercomOverlay,
  } from "@intercom/messenger-js-sdk";
import { useViewTransition } from '@/hooks/useViewTransition';
import { AllCardsModal } from './Modals/AllCardsModal';



type NavigationItem = {
  name: string
  href: string
  imgSrc: string
  current: boolean
  onClick?: () => void
}

function classNames(...classes: (string | boolean | undefined)[]): string {
    return classes.filter(Boolean).join(' ')
  }

export function SidebarContent({ setIsOpen }: { setIsOpen: (open: boolean) => void }) {
    const { openModal } = useModal();
    const { navigateNormal } = useViewTransition(); 

    const navigation: NavigationItem[] = [
        { name: 'Home', href: '#', imgSrc: home, current: true },
        { name: 'Start winning', href: '#', imgSrc: winning, current: false,
            onClick: () => {
                setIsOpen(false);
                openModal(<AllCardsModal />)
            }
        },
        { 
            name: 'My wallet', 
            href: '#', 
            imgSrc: wallet, 
            current: false, 
            onClick: () => {
                setIsOpen(false);
                navigateNormal('/wallet', { 
                    replace: false,
                    viewTransition: false,
                    // preventScrollReset: true, 
                });
            } 
        },
        { 
            name: 'Settings', 
            href: '#', 
            imgSrc: settings, 
            current: false, 
            onClick: () => {
                setIsOpen(false);
                navigateNormal('/settings', { 
                    replace: false,
                    viewTransition: false,
                    // preventScrollReset: true, 
                });
            } 
        },
    ];

    const additionalNavigation: NavigationItem[] = [
        { name: 'Get support', href: '#', imgSrc: chat, current: false,
            onClick: () => {
                setIsOpen(false);
                showIntercomOverlay();
            }
         },
        { name: 'How to play', href: '#', imgSrc: tutorial, current: false, onClick: () => openModal(<TutorialModal />) },
        { name: 'About us', href: '#', imgSrc: heart, current: false,
            onClick: () => {
                setIsOpen(false);
                navigateNormal('/about-us', { 
                    replace: false,
                    viewTransition: false,
                    // preventScrollReset: true, 
                });
            }
        },
        { name: 'Play responsibly', href: '#', imgSrc: responsible, current: false, 
            onClick: () => {
                setIsOpen(false);
                navigateNormal('/play-responsibly', { 
                    replace: false,
                    viewTransition: false,
                    // preventScrollReset: true, 
                });
            }
        },
      ]


    return (
        <SafePaddingContainer orientation='vertical-only' className='bg-white '>
            <div className="flex grow flex-col gap-y-5 overflow-y-auto bg-white px-6 pb-4 w-full h-full">
            <div className="flex shrink-0">
                <HeaderTitle nameColor='text-blue' />
            </div>
            <Profile />
            <nav className="flex flex-1 flex-col">
            <ul className="flex flex-1 flex-col gap-y-7">
                <li>
                <ul className="-mx-2 space-y-1">
                    {navigation.map((item) => (
                    <li key={item.name}>
                        <a
                        className={classNames(
                            item.current
                            ? 'bg-gray-50 text-blue-dark'
                            : 'text-blue-dark hover:bg-gray-50 hover:text-blue-dark',
                            'group flex gap-x-3 rounded-md p-2 text-lg font-semibold',
                        )}
                        // biome-ignore lint/a11y/useValidAnchor: <explanation>
                        onClick={() => {
                            setIsOpen(false)
                            if (item.onClick) {
                                item.onClick();
                            }
                        }}
                        >
                        <img
                            src={item.imgSrc}
                            alt={`${item.name} icon`}
                            className={classNames(
                            item.current ? 'text-blue-dark' : 'text-blue-dark group-hover:text-blue-dark',
                            'size-6 shrink-0',
                            'mr-1'
                            )}
                            width={24}
                            height={24}
                        />
                            {item.name}
                        </a>
                    </li>
                    ))}
                </ul>
                </li>
                <li>
                <div className="text-xl font-semibold leading-6 text-blue-dark">Additional</div>
                <ul className="-mx-2 mt-2 space-y-1">
                    {additionalNavigation.map((item) => (
                    <li key={item.name}>
                        <a
                        className={classNames(
                            item.current
                            ? 'bg-gray-50 text-blue-dark'
                            : 'text-blue-dark hover:bg-gray-50 hover:text-blue-dark',
                            'group flex gap-x-3 rounded-md p-2 text-lg font-semibold',
                        )}
                        // biome-ignore lint/a11y/useValidAnchor: <explanation>
                        onClick={() => {
                            setIsOpen(false)
                            if (item.onClick) {
                                item.onClick();
                            }
                        }}
                        >
                        <img
                            src={item.imgSrc}
                            alt={`${item.name} icon`}
                            className={classNames(
                            item.current ? 'text-blue-dark' : 'text-blue-dark group-hover:text-blue-dark',
                            'size-6 shrink-0',
                            'mr-1'
                            )}
                            width={24}
                            height={24}
                        />
                            {item.name}
                        </a>
                    </li>
                    ))}
                </ul>
                </li>
            </ul>
            </nav>
            </div>
        </ SafePaddingContainer>
    );
}